
import { defineComponent, ref } from 'vue'
import { useElectronicOperatorsModule, ElectronicOperatorsListModel } from '@/modules/electronic-operators'
import { useRouter, useRoute } from 'vue-router'
import { ElectronicOperatorsRouteNames } from '@/router/routes-names'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import usePaginationHelper from '@/views/_shared/search-list/pagination-helper'
import ConfirmDeletionDialog from '@/components/_shared/dialogs/confirm-deletion-dialog.vue'

export default defineComponent({
    name: 'view-electronic-operators-list',
    async setup () {
        const $q = useQuasar()
        const { getElectronicOperators, electronicOperators, deleteElectronicOperator } = useElectronicOperatorsModule()
        const router = useRouter()
        const route = useRoute()
        const { pagination } = usePaginationHelper('name')

        const electronicOperatorsColumns = ([
            { name: 'id', label: 'Id', field: 'id', align: 'left' },
            { name: 'code', label: 'Code', field: 'code', sortable: true, align: 'left' },
            { name: 'name', label: 'Name', field: 'name', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const visibleColumns = ref(['code', 'name', 'actions'])

        function onEditElectronicOperatorRow (evt: PointerEvent | null, props: ElectronicOperatorsListModel) {
            router.push({ name: ElectronicOperatorsRouteNames.EDIT, params: { id: props.id }, query: { page: route.query.page } })
        }

        async function onDeleteElectronicOperatorRow (electronicOperatorRow: ElectronicOperatorsListModel) {
            $q.dialog({
                component: ConfirmDeletionDialog,
                componentProps: {
                    entityType: 'Electronic Operator',
                    entityIdentifier: electronicOperatorRow.name,
                    deleteCallback: async function () {
                        await deleteElectronicOperator(electronicOperatorRow.id)
                    }
                }
            })
        }

        await getElectronicOperators()

        return {
            electronicOperatorsColumns,
            electronicOperators,
            pagination,
            onEditElectronicOperatorRow,
            ElectronicOperatorsRouteNames,
            onDeleteElectronicOperatorRow,
            route,
            visibleColumns
        }
    }
})
